import { WebDynamicCardsService } from './web';
export default WebDynamicCardsService;
